export function removeWhitespaceOnBlur(val: string | null | undefined): string | null | undefined {
    if (!val || typeof val !== 'string') {
        return val;
    }
    return val.trim();
}
